import { Component } from 'shimmer'

import { BodyPart } from '@/webGL/objects/BodyPart'
import { Vector3 } from 'three'
import gsap from 'gsap'

const margin = 3

export class Body extends Component {
  constructor ({ urls, fakePosY }) {
    super({ name: 'body' })

    this.destroy = this.destroy.bind(this)

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.urls = urls
    this.bodyParts = []
    this.currentIndex = 0
    this.promises = []

    this.urls.forEach((url, index) => {
      const bodyPart = new BodyPart({ url })
      bodyPart.basePos = new Vector3(0, fakePosY, 0)
      bodyPart.opacity = 0
      this.bodyParts.push(bodyPart)
      this.promises.push(bodyPart.promise)
    })

    this.add(...this.bodyParts)
    Promise.all(this.promises).then(this.resolve)
  }

  set index (index) {
    this.bodyParts[this.currentIndex].opacity = 0
    // gsap.to(this.bodyParts[this.currentIndex], {
    //   opacity: 0,
    //   duration: .5
    // })

    this.bodyParts[index].opacity = 1
    // gsap.to(this.bodyParts[index], {
    //   opacity: 1,
    //   duration: .5,
    //   delay: .5
    // })

    this.currentIndex = index
  }

  set color (color) {
    this.bodyParts.forEach(part => { part.color = color })
  }

  onDestroy () {
    this.bodyParts.forEach(part => { part.onDestroy() })
    this.destroy()
  }
}